export default "__VITE_ASSET__U4XoR$i6__"